__webpack_require__.p = "https://registries.rewattpower.com/";